import styled from 'styled-components';

export const DirectionButtons = styled.button`
display: flex;
flex-direction: row;
margin: auto auto;
padding: 5px 10px;
font-family: 'Philosopher', sans-serif;
font-size: 16px;
color: #fda;
border:2px solid #fda; 
margin-top: 15px;
margin-bottom: 20px;
cursor: pointer;
background-color: #8A9A5B;
color: #FFF;
background: #232323;
text-shadow: 0 0 5px #FFF, 0 0 10px #FFF, 0 0 15px #FFF, 0 0 20px #49ff18, 0 0 30px #49FF18, 0 0 40px #49FF18, 0 0 55px #49FF18, 0 0 75px #49ff18;

`